import { Field, FieldArray, Form, Formik } from "formik";
import { useState } from "react";
import { Form as BForm, Card, Col, Row, Button } from "react-bootstrap";
import * as Yup from "yup";
import TextInput from "../../../../../components/formfields/InputField";
import { useDispatch, useSelector } from "react-redux";
import { addHomeDataAction } from "../actions";
import CustomPicker from "./CustomPicker";
import { toast } from "react-toastify";
import Freebies from "./Freebies";

const whatSchema = Yup.object({
  freebies_header_line1: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required("line can not be empty"),
    }),
  ),
  freebies_description_line1: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required("line can not be empty"),
    }),
  ),
  freebies_description_line2: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required("line can not be empty"),
    }),
  ),
});

const freebies = {
  title: "",
  link: "",
  numberColor: "",
  hoverColor: "",
  image: "",
};

const FreebiesSection = ({ props }: any) => {
  const [freebiesEdit, setFreebiesEdit] = useState<boolean>(false);
  const [headerLine, setHeaderLine] = useState("");
  const [headerLineColor, setHeaderLineColor] = useState("#7ADBD1");
  const [descriptinLine1, setdescriptionLine1] = useState("");
  const [descriptionLine1Color, setDescriptionLine1Color] = useState("#7ADBD1");
  const [descriptinLine2, setdescriptionLine2] = useState("");
  const [descriptionLine2Color, setDescriptionLine2Color] = useState("#7ADBD1");
  const dispatch = useDispatch();
  const freebies_state = useSelector((state: any) => state?.home?.home_data);

  interface IWhatStateTypes {
    freebies_header_line1: { name: string }[];
    freebies_description_line1: { name: string }[];
    freebies_description_line2: { name: string }[];
    freebies_button: string;
    freebies_button_link: string;
    freebies1: any;
    freebies2: any;
    freebies3: any;
  }

  const whatState: IWhatStateTypes = {
    freebies_header_line1: freebies_state.freebies_header_line1 ? freebies_state.freebies_header_line1 : [],
    freebies_description_line1: freebies_state.freebies_description_line1 ? freebies_state.freebies_description_line1 : [],
    freebies_description_line2: freebies_state.freebies_description_line2 ? freebies_state.freebies_description_line2 : [],
    freebies_button: freebies_state.freebies_button ? freebies_state.freebies_button : "",
    freebies_button_link: freebies_state.freebies_button_link ? freebies_state.freebies_button_link : "",
    freebies1: freebies_state.freebies1 ? freebies_state.freebies1 : { ...freebies },
    freebies2: freebies_state.freebies2 ? freebies_state.freebies2 : { ...freebies },
    freebies3: freebies_state.freebies3 ? freebies_state.freebies3 : { ...freebies },
  };
  const handleFreebiesSubmit = (values: any) => {
    if ((!values.freebies_button && values.freebies_button_link) || (values.freebies_button && !values.freebies_button_link)) {
      toast.error("Please validate the form");
    } else {
      delete values?.freebies1.dummyImage;
      delete values?.freebies2.dummyImage;
      delete values?.freebies3.dummyImage;
      delete values?.freebies1.oldImage;
      delete values?.freebies2.oldImage;
      delete values?.freebies3.oldImage;

      const form_data = new FormData();
      form_data.append("id", "freebies");
      form_data.append("freebies_header_line1", JSON.stringify(values.freebies_header_line1));
      form_data.append("freebies_description_line1", JSON.stringify(values.freebies_description_line1));
      form_data.append("freebies_description_line2", JSON.stringify(values.freebies_description_line2));
      form_data.append("freebies1", JSON.stringify(values.freebies1));
      form_data.append("freebies2", JSON.stringify(values.freebies2));
      form_data.append("freebies3", JSON.stringify(values.freebies3));
      form_data.append("freebies_button", values.freebies_button);
      form_data.append("freebies_button_link", values.freebies_button_link);
      dispatch(addHomeDataAction(form_data, setFreebiesEdit, "add-freebies-section"));
      console.log("freebies_values", values);
      setFreebiesEdit(false);
    }
  };

  return (
    <Formik enableReinitialize initialValues={whatState} validationSchema={whatSchema} onSubmit={handleFreebiesSubmit}>
      {({ values, handleChange, handleBlur, setFieldValue, errors, touched }: any) => {
        return (
          <Form autoComplete="off">
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h6 className="mb-0 fs-lg }">Freebies Section</h6>
                {freebiesEdit ? (
                  <button className="btn btn-primary" type="submit">
                    <i className="fa-regular fa-pen-to-square"></i> Save
                  </button>
                ) : (
                  <span className="btn btn-green" onClick={() => setFreebiesEdit(true)}>
                    <i className="fa-regular fa-pen-to-square"></i> Edit
                  </span>
                )}
              </Card.Header>
              <Card.Body className="position-relative">
                <div
                  className={`position-absolute w-100 h-100 start-0 top-0 zIndex-1 ${freebiesEdit ? "d-none" : ""}`}
                  style={{ background: "rgba(255,255,255,0.5)", cursor: "not-allowed" }}
                ></div>
                {/* Header Line 1 */}
                <FieldArray
                  name="freebies_header_line1"
                  render={(arrayHelpers) => (
                    <>
                      <Row className="gy-3 align-items-end">
                        <Col>
                          <BForm.Label>Header Line 1</BForm.Label>
                          <BForm.Control
                            type="text"
                            readOnly={!freebiesEdit}
                            value={headerLine}
                            onChange={(e) => setHeaderLine(e.target.value)}
                          ></BForm.Control>
                        </Col>
                        <Col>
                          <CustomPicker setValue={setHeaderLineColor} name="color" value={headerLineColor} generator edit={freebiesEdit} />
                        </Col>
                        <Col sm="auto">
                          <Button
                            className="btn-sm btn-icon"
                            disabled={!freebiesEdit}
                            onClick={() => {
                              if (headerLine.trim()) {
                                arrayHelpers.push({
                                  name: headerLine.trim(),
                                  color: headerLineColor,
                                });
                                setHeaderLineColor("#7ADBD1");
                                setHeaderLine("");
                              } else {
                                toast.error("Can't add empty header line");
                              }
                            }}
                          >
                            <i className="fa-regular fa-plus"></i>
                          </Button>
                        </Col>
                      </Row>
                      {values.freebies_header_line1.map((item: any, idx: number) => {
                        return (
                          <Row key={item.name} className="gy-3 align-items-end mt-1">
                            <Col>
                              <Field
                                name={`freebies_header_line1[${idx}].name`}
                                component={TextInput}
                                value={item.name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder={`Line ${idx + 1}`}
                                readOnly={!freebiesEdit}
                              />
                              {errors?.freebies_header_line1 && errors?.freebies_header_line1[idx] && errors?.freebies_header_line1[idx]?.name ? (
                                <div className="errorMessage">{errors.freebies_header_line1[idx].name}</div>
                              ) : null}
                            </Col>
                            <Col>
                              <CustomPicker
                                setFieldValue={setFieldValue}
                                name={`freebies_header_line1[${idx}].color`}
                                value={item.color}
                                edit={freebiesEdit}
                                label=""
                              />
                            </Col>
                            <Col sm="auto">
                              <Button className="btn-sm btn-icon" variant="danger" disabled={!freebiesEdit} onClick={() => arrayHelpers.remove(idx)}>
                                <i className="fa-regular fa-minus"></i>
                              </Button>
                            </Col>
                          </Row>
                        );
                      })}
                    </>
                  )}
                />

                {/* Description Line 1 */}
                <FieldArray
                  name="freebies_description_line1"
                  render={(arrayHelpers) => (
                    <>
                      <Row className="gy-3 align-items-end mt-5">
                        <Col>
                          <BForm.Label>Description Line 1</BForm.Label>
                          <BForm.Control
                            type="text"
                            readOnly={!freebiesEdit}
                            value={descriptinLine1}
                            onChange={(e) => setdescriptionLine1(e.target.value)}
                          ></BForm.Control>
                        </Col>
                        <Col>
                          <CustomPicker setValue={setDescriptionLine1Color} name="color" value={descriptionLine1Color} generator edit={freebiesEdit} />
                        </Col>
                        <Col sm="auto">
                          <Button
                            className="btn-sm btn-icon"
                            disabled={!freebiesEdit}
                            onClick={() => {
                              if (descriptinLine1.trim()) {
                                arrayHelpers.push({
                                  name: descriptinLine1.trim(),
                                  color: descriptionLine1Color,
                                });
                                setDescriptionLine1Color("#7ADBD1");
                                setdescriptionLine1("");
                              } else {
                                toast.error("Can't add empty description line");
                              }
                            }}
                          >
                            <i className="fa-regular fa-plus"></i>
                          </Button>
                        </Col>
                      </Row>
                      {values.freebies_description_line1.map((item: any, idx: number) => {
                        return (
                          <Row key={item.name} className="gy-3 align-items-end mt-1">
                            <Col>
                              <Field
                                name={`freebies_description_line1[${idx}].name`}
                                component={TextInput}
                                value={item.name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder={`Line ${idx + 1}`}
                                readOnly={!freebiesEdit}
                                className={freebiesEdit ? "editField" : ""}
                              />
                              {errors?.freebies_description_line1 &&
                              errors?.freebies_description_line1[idx] &&
                              errors?.freebies_description_line1[idx]?.name ? (
                                <div className="errorMessage">{errors.freebies_description_line1[idx].name}</div>
                              ) : null}
                            </Col>
                            <Col>
                              <CustomPicker
                                setFieldValue={setFieldValue}
                                name={`freebies_description_line1[${idx}].color`}
                                value={item.color}
                                edit={freebiesEdit}
                                label=""
                              />
                            </Col>
                            <Col sm="auto">
                              <Button className="btn-sm btn-icon" variant="danger" disabled={!freebiesEdit} onClick={() => arrayHelpers.remove(idx)}>
                                <i className="fa-regular fa-minus"></i>
                              </Button>
                            </Col>
                          </Row>
                        );
                      })}
                    </>
                  )}
                />

                {/* Description Line 2 */}
                <FieldArray
                  name="freebies_description_line2"
                  render={(arrayHelpers) => (
                    <>
                      <Row className="gy-3 align-items-end mt-5">
                        <Col>
                          <BForm.Label>Description Line 2</BForm.Label>
                          <BForm.Control
                            type="text"
                            readOnly={!freebiesEdit}
                            value={descriptinLine2}
                            onChange={(e) => setdescriptionLine2(e.target.value)}
                          ></BForm.Control>
                        </Col>
                        <Col>
                          <CustomPicker setValue={setDescriptionLine2Color} name="color" value={descriptionLine2Color} generator edit={freebiesEdit} />
                        </Col>
                        <Col sm="auto">
                          <Button
                            className="btn-sm btn-icon"
                            disabled={!freebiesEdit}
                            onClick={() => {
                              if (descriptinLine2.trim()) {
                                arrayHelpers.push({
                                  name: descriptinLine2.trim(),
                                  color: descriptionLine2Color,
                                });
                                setDescriptionLine2Color("#7ADBD1");
                                setdescriptionLine2("");
                              } else {
                                toast.error("Can't add empty description line");
                              }
                            }}
                          >
                            <i className="fa-regular fa-plus"></i>
                          </Button>
                        </Col>
                      </Row>
                      {values.freebies_description_line2.map((item: any, idx: number) => {
                        return (
                          <Row key={item.name} className="gy-3 align-items-end mt-1">
                            <Col>
                              <Field
                                name={`freebies_description_line2[${idx}].name`}
                                component={TextInput}
                                value={item.name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder={`Line ${idx + 1}`}
                                readOnly={!freebiesEdit}
                                className={freebiesEdit ? "editField" : ""}
                              />
                              {errors?.freebies_description_line2 && errors?.freebies_description_line2[idx] && errors?.freebies_description_line2[idx].name ? (
                                <div className="errorMessage">{errors.freebies_description_line2[idx].name}</div>
                              ) : null}
                            </Col>
                            <Col>
                              <CustomPicker
                                setFieldValue={setFieldValue}
                                name={`freebies_description_line2[${idx}].color`}
                                value={item.color}
                                edit={freebiesEdit}
                                label=""
                              />
                            </Col>
                            <Col sm="auto">
                              <Button className="btn-sm btn-icon" variant="danger" disabled={!freebiesEdit} onClick={() => arrayHelpers.remove(idx)}>
                                <i className="fa-regular fa-minus"></i>
                              </Button>
                            </Col>
                          </Row>
                        );
                      })}
                    </>
                  )}
                />

                <Row className="gy-3 align-items-end mt-2">
                  <Col sm={4}>
                    <label className="form-label">Button</label>
                    <Field
                      name="freebies_button"
                      component={TextInput}
                      value={values.freebies_button}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Button"
                      readOnly={!freebiesEdit}
                      className={freebiesEdit ? "editField" : ""}
                    />
                    {!values.freebies_button && values.freebies_button_link ? <div className="errorMessage">Enter button text</div> : null}
                  </Col>
                  <Col sm={8}>
                    <label className="form-label">Button Link</label>
                    <Field
                      name="freebies_button_link"
                      component={TextInput}
                      value={values.freebies_button_link}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Button link"
                      readOnly={!freebiesEdit}
                      className={freebiesEdit ? "editField" : ""}
                    />
                    {values.freebies_button && !values.freebies_button_link ? <div className="errorMessage">Enter button Link</div> : null}
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            <div className="position-relative">
              <div
                className={`position-absolute w-100 h-100 start-0 top-0 zIndex-1 ${freebiesEdit ? "d-none" : ""}`}
                style={{ background: "rgba(255,255,255,0.5)", cursor: "not-allowed" }}
              ></div>
              <Freebies
                section="freebies1"
                values={values}
                props={props}
                setFieldValue={setFieldValue}
                handleBlur={handleBlur}
                handleChange={handleChange}
                sectionEdit={freebiesEdit}
                uploadFileNewAction={props.uploadFileNewAction}
              />
              <Freebies
                section="freebies2"
                values={values}
                props={props}
                setFieldValue={setFieldValue}
                handleBlur={handleBlur}
                handleChange={handleChange}
                sectionEdit={freebiesEdit}
                uploadFileNewAction={props.uploadFileNewAction}
              />
              <Freebies
                section="freebies3"
                values={values}
                props={props}
                setFieldValue={setFieldValue}
                handleBlur={handleBlur}
                handleChange={handleChange}
                sectionEdit={freebiesEdit}
                uploadFileNewAction={props.uploadFileNewAction}
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default FreebiesSection;
